'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Heading_module = require('../styles/Heading.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/** Helper function */
const convertSizeAdaptiveToClassNames = (size) => {
    if (reactUtils.isUndefined(size))
        return [];
    const breakpoints = Object.keys(size);
    const createName = (breakpoint) => breakpoint === 'mobile'
        ? size[breakpoint]
        : `${breakpoint}-${size[breakpoint]}`;
    return breakpoints.map((breakpoint) => `size-${createName(breakpoint)}`);
};
/**
 * @description The Heading component is used for all headings.
 *
 * @component
 * @example
 * ```jsx
 * <Heading level={2}>
 *   Heading
 * </Heading>
 * ```
 */
const Heading = React__namespace.forwardRef((props, ref) => {
    const { as, level, size, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Heading_module.default);
    const sizeAdaptive = React__namespace.useMemo(() => (reactUtils.isNumber(size) ? { mobile: size } : size), [size]);
    const sizeBreakpoints = size ? convertSizeAdaptiveToClassNames(sizeAdaptive) : [];
    const classNames = cx(className, 'container', {
        [`level-${level}`]: level,
    }, ...sizeBreakpoints);
    return React__namespace.createElement(as || `h${level}`, {
        ref,
        className: classNames,
        ...restProps,
    }, children);
});
Heading.defaultProps = {
    level: 1,
};
Heading.displayName = 'Heading';

exports.Heading = Heading;
//# sourceMappingURL=Heading.js.map
